import _taggedTemplateLiteral from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n    position: absolute;\n    top: -4px;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n    border-top: 1px solid ", ";\n    padding-top: ", "px;\n    padding-bottom: ", "px;\n    word-break: break-word;\n\n    ", ":first-child & {\n        border-top: 0;\n    }\n\n    ", ";\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n    padding-top: ", "px;\n    padding-bottom: ", "px;\n    color: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n    white-space: nowrap;\n\n    ", ";\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    padding-left: ", "px;\n    padding-right: ", "px;\n    ", ";\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    align-items: flex-start;\n    padding: 0 ", "px;\n    ", ";\n\n    &:hover {\n        background-color: ", ";\n        border-radius: ", ";\n    }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    position: relative;\n    align-items: center;\n    margin: 0;\n    height: 50px;\n    padding: 0 ", "px;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    flex-flow: row nowrap;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    outline: none;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    flex-grow: 1;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    &:first-child {\n        padding-left: 0;\n    }\n\n    &:last-child {\n        padding-right: 0;\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { useCallback, useLayoutEffect, useMemo, useRef } from 'react';
import styled, { css } from 'styled-components';
import { transparentize } from 'polished';
import { AutoSizer, List as VirtualizedList, CellMeasurer, CellMeasurerCache } from 'react-virtualized';
import { Progress } from '../Progress';
import { transitions, typography } from '../mixins';
import { Checkbox } from '../Checkbox';
import { noop } from '../helpers';
var firstLastCellMargin = css(_templateObject());
var Container = styled.div(_templateObject2());
var StyledList = styled(VirtualizedList)(_templateObject3());
var Row = styled.div(_templateObject4());
var HeaderRow = styled(Row)(_templateObject5(), function (_ref) {
  var offset = _ref.offset;
  return offset;
});
var BodyRow = styled(Row)(_templateObject6(), function (_ref2) {
  var offset = _ref2.offset;
  return offset;
}, transitions(['border-color', 'color', 'background-color']).easeOut().standard(), function (_ref3) {
  var theme = _ref3.theme;
  return transparentize(0.95, theme.palette.primary.main);
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.shape.borderRadius.large;
});
var Cell = styled.div(_templateObject7(), function (_ref5) {
  var theme = _ref5.theme;
  return theme.unit * 2;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.unit * 2;
}, typography('body1'));
var HeaderCell = styled(Cell)(_templateObject8(), function (_ref7) {
  var theme = _ref7.theme;
  return theme.unit * 3;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.unit * 3;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.palette.gray.gray900;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.typography.action.fontWeight;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.typography.action.lineHeight;
}, firstLastCellMargin);
var BodyCell = styled(Cell)(_templateObject9(), function (_ref12) {
  var theme = _ref12.theme;
  return theme.palette.gray.gray100;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.unit * 5;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.unit * 5;
}, BodyRow, firstLastCellMargin);
var LoadingProgress = styled(Progress)(_templateObject10());
var cache = new CellMeasurerCache({
  defaultHeight: 50,
  fixedWidth: true
});

function childToColumn(_ref15) {
  var props = _ref15.props;
  var width = props.width,
      _props$flexGrow = props.flexGrow,
      flexGrow = _props$flexGrow === void 0 ? 0 : _props$flexGrow,
      _props$flexShrink = props.flexShrink,
      flexShrink = _props$flexShrink === void 0 ? 1 : _props$flexShrink,
      _props$textAlign = props.textAlign,
      textAlign = _props$textAlign === void 0 ? 'left' : _props$textAlign,
      dataKey = props.dataKey,
      label = props.label,
      cellRenderer = props.cellRenderer,
      columnData = props.columnData;
  return {
    flex: "".concat(flexGrow, " ").concat(flexShrink, " ").concat(width, "px"),
    textAlign: textAlign,
    dataKey: dataKey,
    label: label,
    cellRenderer: cellRenderer,
    columnData: columnData
  };
}

function getDefaultRowId(_ref16) {
  var id = _ref16.id,
      orderId = _ref16.orderId,
      globalId = _ref16.globalId,
      oneTransportId = _ref16.oneTransportId;
  return id || orderId || globalId || oneTransportId;
}

export function Table(_a) {
  var _a$rows = _a.rows,
      rows = _a$rows === void 0 ? [] : _a$rows,
      _a$loading = _a.loading,
      loading = _a$loading === void 0 ? false : _a$loading,
      noRowsRenderer = _a.noRowsRenderer,
      _a$offset = _a.offset,
      offset = _a$offset === void 0 ? 0 : _a$offset,
      children = _a.children,
      _a$getRowId = _a.getRowId,
      getRowId = _a$getRowId === void 0 ? getDefaultRowId : _a$getRowId,
      _a$rowSelection = _a.rowSelection,
      rowSelection = _a$rowSelection === void 0 ? false : _a$rowSelection,
      _a$selectedRowIds = _a.selectedRowIds,
      selectedRowIds = _a$selectedRowIds === void 0 ? [] : _a$selectedRowIds,
      _a$onSelect = _a.onSelect,
      onSelect = _a$onSelect === void 0 ? noop : _a$onSelect,
      _a$onSelectAll = _a.onSelectAll,
      onSelectAll = _a$onSelectAll === void 0 ? noop : _a$onSelectAll,
      props = __rest(_a, ["rows", "loading", "noRowsRenderer", "offset", "children", "getRowId", "rowSelection", "selectedRowIds", "onSelect", "onSelectAll"]);

  var columns = children ? React.Children.map(children, childToColumn) : [];
  var listRef = useRef(null);
  var lastRenderedWidth = useRef(0);
  var lastRenderedRows = useRef([]);
  useLayoutEffect(function () {
    var currentRows = rows.map(getRowId);
    var difference = lastRenderedRows.current.reduce(function (acc, rowId, index) {
      if (rowId !== currentRows[index]) {
        acc.push(index);
      }

      return acc;
    }, []);
    lastRenderedRows.current = currentRows;
    difference.forEach(function (rowIndex) {
      return cache.clear(rowIndex, 0);
    });

    if (difference.length && listRef.current) {
      listRef.current.recomputeRowHeights(difference[0]);
    }
  }, [rows]);
  var renderRow = useCallback(function (_ref17) {
    var parent = _ref17.parent,
        index = _ref17.index,
        key = _ref17.key,
        style = _ref17.style;
    var rowData = rows[index];
    var rowId = getRowId(rowData);
    return React.createElement(CellMeasurer, {
      cache: cache,
      columnIndex: 0,
      key: key,
      parent: parent,
      rowIndex: index
    }, React.createElement(BodyRow, {
      key: key,
      style: style,
      offset: offset
    }, rowSelection && React.createElement(BodyCell, null, React.createElement(Checkbox, {
      id: "gui-table-select-".concat(rowId),
      checked: selectedRowIds.includes(rowId),
      onChange: function onChange(_ref18) {
        var target = _ref18.target;
        onSelect(rowId, target.checked);
      }
    })), columns.map(function (_ref19) {
      var flex = _ref19.flex,
          textAlign = _ref19.textAlign,
          dataKey = _ref19.dataKey,
          columnData = _ref19.columnData,
          cellRenderer = _ref19.cellRenderer;
      return React.createElement(BodyCell, {
        key: "row-".concat(index, "-").concat(dataKey),
        style: {
          flex: flex,
          textAlign: textAlign
        }
      }, cellRenderer({
        rowData: rowData,
        columnData: columnData
      }));
    })));
  }, [rows, offset]);
  var renderNoRows = useCallback(function () {
    return loading || !noRowsRenderer ? null : noRowsRenderer();
  }, [loading, noRowsRenderer]);
  var selectAllCell = useMemo(function () {
    if (!rowSelection) {
      return null;
    }

    var hasRows = rows.length > 0;

    var selectAll = function selectAll(_ref20) {
      var target = _ref20.target;
      onSelectAll(target.checked);
    };

    return React.createElement(HeaderCell, null, React.createElement(Checkbox, {
      id: 'gui-table-select-all',
      checked: hasRows && selectedRowIds.length === rows.length,
      disabled: !hasRows,
      indeterminate: selectedRowIds.length > 0 && selectedRowIds.length < rows.length,
      onChange: selectAll
    }));
  }, [rows, rowSelection, selectedRowIds, onSelectAll]);
  return React.createElement(React.Fragment, null, React.createElement(HeaderRow, {
    offset: offset
  }, selectAllCell, columns.map(function (_ref21) {
    var flex = _ref21.flex,
        textAlign = _ref21.textAlign,
        label = _ref21.label,
        dataKey = _ref21.dataKey;
    return React.createElement(HeaderCell, {
      key: "header-".concat(dataKey),
      style: {
        flex: flex,
        textAlign: textAlign
      }
    }, label);
  })), React.createElement(Container, null, React.createElement(LoadingProgress, {
    loading: loading,
    size: 'large'
  }), React.createElement(AutoSizer, null, function (_ref22) {
    var width = _ref22.width,
        height = _ref22.height;

    if (lastRenderedWidth.current !== width) {
      lastRenderedWidth.current = width;
      cache.clearAll();
    }

    return React.createElement(StyledList, Object.assign({
      ref: listRef,
      deferredMeasurementCache: cache,
      estimatedRowSize: 184,
      height: height,
      width: width,
      rowCount: rows.length,
      rowHeight: cache.rowHeight,
      rowRenderer: renderRow,
      noRowsRenderer: renderNoRows
    }, props));
  })));
}